<template>
    <div class="entity-compare">
        <v-row class="entity-compare-header m-0">
            <v-col cols="6" class="header-col left"><h4>Before</h4></v-col>
            <v-col cols="6" class="header-col right"><h4>After</h4></v-col>
        </v-row>
        <v-row class="entity-compare-body m-0">
            <v-col cols="6" class="body-col left">
                <notification-laboratories-approval-request-form
                    :store="laboratory"
                    :is-afert="true"
                ></notification-laboratories-approval-request-form>
            </v-col>

            <v-col cols="6" class="body-col right">
                <notification-laboratories-approval-request-form
                    :store="laboratorySnapShot"
                ></notification-laboratories-approval-request-form>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    name: 'NotificationLaboratoriesApprovalRequest',
    components: {},
    props: {},
    data() {
        return {};
    },
    computed: {
        notification() {
            return this.$store.state.notifications.current;
        },
        laboratory() {
            return this.$store.state.notification_laboratory.laboratory;
        },
        laboratorySnapShot() {
            return this.$store.state.notification_laboratory.laboratorySnapShot;
        },
    },
    watch: {},
    created() {},
    methods: {},
};
</script>
